
import { defineComponent } from "vue"

export default defineComponent({
	setup() {
		const sites = [
			{
				title: "参考",
				description:
					"恐縮ながら、こちらのサイトを参考に制作させていただきました。ありがとうございました。",
				data: [
					{
						author: "かぢゃぽんのお部屋",
						title: "PS2PAR解析部屋",
						url: "http://www5.airnet.ne.jp/kajapon/"
					},
					{
						author: "zero memory",
						title: "PS2PARコード変換スクリプト",
						url: "http://www.big.or.jp/~dram/ps2code.html"
					},
					{
						title: "PS2PARコード→pnach用コード変換スクリプト",
						url: "https://ps2par-pnach.blogspot.com/"
					}
				]
			},
			{
				title: "サードパーティーライセンス",
				data: [
					{
						author: "Ionic",
						title: "Ionicons",
						url: "https://ionic.io/ionicons"
					},
					{
						title: "その他",
						url: "./ThirdPartyNotices.txt"
					}
				]
			}
		]

		return { sites }
	}
})
